import { useQuery } from '@tanstack/react-query'

import {
  getAllBookingProducts,
  getAllProductsAvailability,
} from '@flecto/api/saas'
import {
  type CoreBooking,
  type CoreProductSelection,
  type ParameterID,
} from '@flecto/types'
import { isValidParameterID } from '@flecto/utils'

type QueryPayload = {
  bookingId?: ParameterID
  startAt?: string
  endAt?: string
}
export function useQueryGetAllBookingProductsSelection({
  bookingId,
  startAt,
  endAt,
}: QueryPayload) {
  return useQuery({
    queryKey: ['QueryGetAllBookingProductsSelection', bookingId],
    refetchOnWindowFocus: false,
    enabled: isValidParameterID(bookingId),
    initialData: [],
    queryFn: async () => {
      const [productsAvailabilityResponse, bookingProductsResponse] =
        await Promise.all([
          getAllProductsAvailability({
            start_at: startAt ?? '',
            end_at: endAt ?? '',
            quantity: 1,
          }),
          getAllBookingProducts(bookingId ?? ''),
        ])

      const productsSelected = new Map<ParameterID, CoreProductSelection>()

      productsAvailabilityResponse?.product_availability?.forEach(
        ({ product, remaining_quantity }) => {
          productsSelected.set(String(product.id), {
            product,
            remaining_quantity,
          })
        }
      )

      bookingProductsResponse?.forEach((bookingProduct) => {
        const product = productsSelected.get(String(bookingProduct.product.id))

        if (product) {
          product.bookingProduct = {
            booking: bookingProduct.booking as unknown as CoreBooking,
            id: bookingProduct.id,
            quantity: bookingProduct.quantity,
            insured: bookingProduct.insured,
            picked_up_quantity: bookingProduct.picked_up_quantity,
            product: bookingProduct.product,
          }
        }
      })

      return Array.from(productsSelected.values())
    },
  })
}
